import { buildAction } from './helpers';
import { EMPTY_OBJECT, SET_UI_COLORS } from '../constants';

export function setColors(colors) {
  return buildAction(SET_UI_COLORS, colors);
}

export function clearColors() {
  return buildAction(SET_UI_COLORS, EMPTY_OBJECT);
}



// WEBPACK FOOTER //
// ./src/actions/ui.js